import { useTheme } from "@mui/material/styles";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import PropTypes from "prop-types";

import { EchartTheme } from "../MatxTheme";

export default function EchartCreator({ height, option }) {
  const theme = useTheme();
  echarts.registerTheme("echarts-theme", EchartTheme(theme));

  return (
    <ReactEcharts
      option={option}
      lazyUpdate={true}
      theme="echarts-theme"
      style={{ height: height, width: "100%" }}
    />
  );
}

EchartCreator.prototype = {
  height: PropTypes.string.isRequired,
  option: PropTypes.object.isRequired
};
